module.exports = __webpack_public_path__ + "static/media/12.145f2918.jpg";